import { useEffect, useState } from 'react';
import { useToast } from '../context/ToastContext.jsx';
import '../styles/components/ToastStyle.css';

const ICONS = {
  success: 'fa-circle-check',
  error: 'fa-circle-exclamation',
  warning: 'fa-triangle-exclamation',
  info: 'fa-circle-info',
};

export function Toaster() {
  const { toasts, dismissToast } = useToast();

  return (
    <div className="toast-container" aria-live="polite" aria-atomic="true">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onDismiss={() => dismissToast(toast.id)} />
      ))}
    </div>
  );
}

function Toast({ toast, onDismiss }) {
  const [isExiting, setExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setExiting(true), toast.duration);

    return () => clearTimeout(timer);
  }, [toast.duration]);

  return (
    <div
      className={`toast toast--${toast.type}${isExiting ? ' is-exiting' : ''}`}
      role="status"
      aria-live={toast.type === 'error' ? 'assertive' : 'polite'}
      onClick={() => setExiting(true)}
      onAnimationEnd={(event) => {

        if (isExiting && event.target === event.currentTarget) onDismiss();
      }}
    >
      <span className="toast-icon">
        <i className={`fa-solid ${ICONS[toast.type] ?? ICONS.success}`} />
      </span>
      <span>{toast.message}</span>
      <div className="toast-progress" style={{ animationDuration: `${toast.duration}ms` }} />
    </div>
  );
}
